import { useTranslation } from "react-i18next";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { SupplierScoreBase, HintConfig } from "./SupplierScoreBase";
import { useIngredientContext } from "../../useIngredientContext";
import { useCompanyMetadata } from "src/context/Company/Metadata/useCompanyMetadata";
import { Loading } from "src/components/utils/Loading";

/**
 * Business component for scores with a single supplier
 * Contains logic specific to the one supplier case
 */
export const OneSupplierScore = () => {
    const { t } = useTranslation();
    const { ingredient, scores, areScoresRefetching, ingredientReference, isIngredientReferenceReady, activePost } =
        useIngredientContext();

    const { isUserOfTypeSupplier } = useFoodpilotContext();
    const { company } = useCompanyMetadata();

    if (!ingredient) {
        return <Loading />;
    }

    const isSupplier = isUserOfTypeSupplier();
    const ownedById = ingredient.ownedBy?.id;
    const isIngredientOwned = company.id === ownedById;

    const hintConfig: HintConfig = {
        title: t("attention_cet_ingredient_n_a_qu_un_seul_fournisseur_associe"),
        content: t("ses_indicateurs_ne_dependent_donc_que_des_donnees_et_des_informations_de_ce_fournisseur"),
        shouldShow: !isSupplier && isIngredientOwned,
    };

    return (
        <SupplierScoreBase
            ingredient={ingredient}
            scores={scores}
            areScoresRefetching={areScoresRefetching}
            ingredientReference={ingredientReference}
            isIngredientReferenceReady={isIngredientReferenceReady}
            hintConfig={hintConfig}
            post={activePost}
        />
    );
};
